import { Injectable, EventEmitter } from '@angular/core';
import { Location } from '../model/location';
import { HttpHelper } from './http.service';
import { AppConfig } from '../model/config';
import {SettingsService} from "./settings.service";

@Injectable()
export class LocationService {

  public Locations: Location[];
  public locationsLoaded$: EventEmitter<Location[]>;

  constructor(private readonly http: HttpHelper, private readonly configuration: AppConfig, private readonly settingService: SettingsService) {

    this.locationsLoaded$ = new EventEmitter<Location[]>();

  }

  public async loadLocations() {

    console.log("Load locations");

    const uri = this.configuration.backendUrl;

    // locations
    await this.http.get(uri + "/api/location/allLocations?airport=" + this.settingService.getCurrentAirport(), (data: Location[]) => {

      this.Locations = [];

      data.forEach((location) => { this.Locations.push(new Location(location)); });
      if (data.length == 0) {
        console.log("locations zero");
      }

      this.locationsLoaded$.emit(this.Locations);

    }, (error) => { }).toPromise<any>();
  }

}
